import React from "react";
import ReactDOM from "react-dom/client";
import { PublicClientApplication, EventType } from "@azure/msal-browser";
import { MsalProvider } from "@azure/msal-react";
import App from "./App";
import ErrorBoundary from "./components/ErrorBoundary";
import SetupRequired from "./components/SetupRequired";
import { msalConfig, isConfigured } from "./authConfig";
import "./styles/global.css";

// ─── Preserve share token across MSAL redirect ───
// When user clicks a share link but isn't logged in, MSAL will redirect
// to Microsoft login and back. The ?share= parameter gets lost in redirect.
// Save it to localStorage so we can restore it after authentication.
(function preserveShareToken() {
  const params = new URLSearchParams(window.location.search);
  const shareToken = params.get("share");
  if (shareToken) {
    localStorage.setItem("ctodocx_pending_share", shareToken);
  }
})();

const root = ReactDOM.createRoot(document.getElementById("root"));

if (!isConfigured) {
  root.render(
    <React.StrictMode>
      <SetupRequired />
    </React.StrictMode>
  );
} else {
  const msalInstance = new PublicClientApplication(msalConfig);

  msalInstance.addEventCallback((event) => {
    if (
      (event.eventType === EventType.LOGIN_SUCCESS ||
        event.eventType === EventType.ACQUIRE_TOKEN_SUCCESS) &&
      event.payload?.account
    ) {
      msalInstance.setActiveAccount(event.payload.account);
    }
  });

  msalInstance
    .initialize()
    .then(() => msalInstance.handleRedirectPromise())
    .catch((error) => {
    })
    .finally(() => {
      if (!msalInstance.getActiveAccount()) {
        const accounts = msalInstance.getAllAccounts();
        if (accounts.length > 0) {
          msalInstance.setActiveAccount(accounts[0]);
        }
      }

      root.render(
        <React.StrictMode>
          <ErrorBoundary>
            <MsalProvider instance={msalInstance}>
              <App />
            </MsalProvider>
          </ErrorBoundary>
        </React.StrictMode>
      );
    });
}
